import { render } from "./price.vue?vue&type=template&id=4d1440c4&ts=true"
import script from "./price.vue?vue&type=script&lang=ts"
export * from "./price.vue?vue&type=script&lang=ts"

import "./price.vue?vue&type=style&index=0&id=4d1440c4&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__